import React, { Component } from "react"
import Modal from "react-modal"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"
import {
  LogoutUser,
  recreateUserPassword,
  fetchPriceListByStationId,
} from "../../../actions"
import { reportFBEvent } from "../../../actions/FBEventsActions"
import { validation } from "../../../utils"
import PricesTableByType from "../../Modals/PricesListModal/PricesTableByType"
import WarningInfoModal from "../../Modals/WarningInfoModal"
import YesNoInfoModal from "../../Modals/YesNoInfoModal"
import WhatsApp from "../../../assets/svg/whatsapp.svg"
import SupportPhone from "../../../assets/svg/support_phone.svg"

import "./style.css"

class FixedHeader extends Component {
  constructor(props) {
    super(props)

    this.state = {
      showYesNoModal: false,
      showPricesList: false,
      showRecreatePasswordModal: false,
      showInterruptProsessModal: false,
    }
  }

  componentWillReceiveProps(newProps) {
    const {
      serviceInternetError,
      reactInternetError,
      stationId,
      doNotInterruptTheProcess,
    } = newProps

    if (
      !stationId ||
      stationId === -1 ||
      serviceInternetError === true ||
      reactInternetError === true
    ) {
      if (doNotInterruptTheProcess === true) {
        this.setState({ showInterruptProsessModal: true })

        this.props.reportFBEvent(
          "FixedHeader ",
          "Show message on InterruptTheProsess. "
        )
      } else {
        this.props.history.push("/MaintenanceScreen")
      }
    }
  }

  headerButtons = (buttonsFlag) => {
    const {
      price_list,
      login_courier,
      sms_login_didnot_get_sms,
      forgot_password_btn_text,
      register_btn_text,
      mobile,
      logout_btn_text,
      stationId,
      langName,
    } = this.props
    if (buttonsFlag === "showRestoreDeliveryCode") {
      return (
        <div
          className="header-button"
          onClick={() => this.props.history.push("/RestoreDeliveryCodeScreen")}
        >
          {sms_login_didnot_get_sms}
        </div>
      )
    }
    if (buttonsFlag === "loginScreen") {
      return (
        <div
          className="header-button"
          onClick={() => this.onSendMobileToRestorePasswordClick(mobile)}
        >
          {forgot_password_btn_text}
        </div>
      )
    }
    if (buttonsFlag === "userLoginScreen") {
      return (
        <>
          <div
            className="header-button"
            onClick={async () => {
              await this.props.fetchPriceListByStationId(stationId, langName)
              this.setState({
                showPricesList: true,
              })
            }}
          >
            {price_list}
          </div>
          {
            //<div  className="header-button"  onClick=() => this.onSendMobileToRestorePasswordClick(mobile)>
            //forgot_password_btn_text</div>
          }
          <div
            className="header-button"
            onClick={() => this.props.history.push("/SignUpStep1Screen")}
          >
            {register_btn_text}
          </div>
        </>
      )
    }
    if (buttonsFlag === "senderDetailsScreen") {
      return (
        <>
          <div
            className="header-button"
            onClick={async () => {
              await this.props.fetchPriceListByStationId(stationId, langName)
              this.setState({
                showPricesList: true,
              })
            }}
          >
            {price_list}
          </div>

          <div
            className="header-button"
            onClick={() => this.props.history.push("/SignUpStep1Screen")}
          >
            {register_btn_text}
          </div>
        </>
      )
    }
    if (
      buttonsFlag === "passwordUpdateScreen" ||
      buttonsFlag === "signUpStep1Screen" ||
      buttonsFlag === "aboutRental" ||
      buttonsFlag === "scan_waybill" ||
      buttonsFlag === "manualWaybillScreen" ||
      buttonsFlag === "shipingChooseLockerScreen"
    ) {
      return null
    }
    if (
      buttonsFlag === "loadCleanOrdersScreen" ||
      buttonsFlag === "driverMenuScreen" ||
      buttonsFlag === "orderDepositScreen" ||
      buttonsFlag === "collectOrdersScreen" ||
      buttonsFlag === "unlockLockersScreen"
    ) {
      return (
        <div
          className="header-button"
          onClick={() =>
            this.setState({
              showYesNoModal: true,
            })
          }
        >
          {logout_btn_text}
        </div>
      )
    }
    if (
      buttonsFlag === "userMenuScreen" ||
      buttonsFlag === "newOrderScreen" ||
      buttonsFlag === "collectOrderScreen" ||
      buttonsFlag === "newLockerToLockerScreen"
    ) {
      return (
        <>
          <div
            className="header-button"
            onClick={async () => {
              await this.props.fetchPriceListByStationId(stationId, langName)
              this.setState({
                showPricesList: true,
              })
            }}
          >
            {price_list}
          </div>
          <div
            className="header-button"
            onClick={() =>
              this.setState({
                showYesNoModal: true,
              })
            }
          >
            {logout_btn_text}
          </div>
        </>
      )
    }

    return (
      <>
        <div
          className="header-button"
          onClick={async () => {
            await this.props.fetchPriceListByStationId(stationId, langName)
            this.setState({
              showPricesList: true,
            })
          }}
        >
          {price_list}
        </div>
        <div
          className="header-button"
          onClick={() =>
            this.props.history.push("/LoginScreen", "driversLogin")
          }
        >
          {login_courier}
        </div>
        <div
          className="header-button"
          onClick={() => this.props.history.push("/SignUpStep1Screen")}
        >
          {register_btn_text}
        </div>
      </>
    )
  }

  onSendMobileToRestorePasswordClick(mobile) {
    if (!validation.Mobile05(mobile)) {
      this.props.history.push("/RecreatePasswordScreen")
      return
    }

    this.setState({ showRecreatePasswordModal: true })
    this.props.recreateUserPassword(mobile)
  }

  setName = (firstName) => {
    if (firstName != null) return firstName
    return ""
  }
  newlineText(text) {
    if (text === undefined || text === null || text.length <= 0) {
      return text
    }
    return text.split("\n").map((str) => <p>{str}</p>)
  }
  onClickInterruptProsessModal = () => {
    this.props.reportFBEvent("FixedHeader ", "Clicked InterruptProsessModal. ")

    const { stationId, serviceInternetError, reactInternetError } = this.props
    this.setState({ showInterruptProsessModal: false })
    if (
      !stationId ||
      stationId === -1 ||
      serviceInternetError === true ||
      reactInternetError === true
    ) {
      this.props.history.push("/MaintenanceScreen")
    }
  }
  render() {
    const {
      dirRtl,
      customer_service_text,
      customer_service_phone_text,
      customer_service_whatsapp_text,
      pricesArrs,
      asterisk,
      close_text,
      price_list,
      buttonsFlag,
      reset_pwd_modal_title,
      reset_pwd_modal_body,
      logout_modal_title,
      logout_modal_text,
      ok_text,
      cancel_text,
      attention_prosess_interrapted,
      care_your_package,
    } = this.props
    const {
      showRecreatePasswordModal,
      showYesNoModal,
      showInterruptProsessModal,
    } = this.state

    const { showPricesList } = this.state

    return (
      <div className="fh-header">
        <div className="header-buttons">{this.headerButtons(buttonsFlag)}</div>

        <div className="fh-header-itm">
          <div className="customer-service" dir={`${dirRtl ? "rtl" : "ltr"}`}>
            <div>{`${customer_service_text}`} </div>
            <div className="space">&nbsp;</div>
            <div className="support-phone">
              <img src={SupportPhone} alt="support phone" />
            </div>
            <div>{`${customer_service_phone_text}`}</div>

            <div>{`${dirRtl ? asterisk : ""}`}</div>
            <div className="space">&nbsp;</div>
            <div className="icon-app">
              <img src={WhatsApp} alt="whatsapp" />
            </div>
            <div>{`${customer_service_whatsapp_text}`}</div>
          </div>
        </div>

        <Modal
          isOpen={showPricesList}
          onRequestClose={() => this.setState({ showPricesList: false })}
          className="react-modal-content tall-modal"
          overlayClassName="modal-overlay"
        >
          <div className="pricelist-title">{`₪ ${price_list}`}</div>

          <div className={`${dirRtl ? "dirrtl" : "dirltr"} price-modal-body`}>
            {pricesArrs.map((pricesArr, index) => {
              if (pricesArr.length < 1) {
                return ""
              }
              const { productType } = pricesArr[0]
              return (
                <PricesTableByType
                  itemsArr={pricesArr}
                  tableTitle={productType}
                  key={index}
                />
              )
            })}
          </div>
          <button
            className="close-btn"
            onClick={() => {
              this.setState({ showPricesList: false })
            }}
          >
            {close_text}
          </button>
        </Modal>
        <WarningInfoModal
          dirRtl={dirRtl}
          show={showRecreatePasswordModal}
          title={reset_pwd_modal_title}
          text={reset_pwd_modal_body}
          onModalCloseClick={() =>
            this.setState({
              showRecreatePasswordModal: false,
            })
          }
          btnText={close_text}
        />
        <YesNoInfoModal
          dirRtl={dirRtl}
          show={showYesNoModal}
          title={logout_modal_title}
          text={logout_modal_text}
          onModalOkClick={() => {
            this.props.LogoutUser()
            this.props.history.push("")
          }}
          onModalCancelClick={() => this.setState({ showYesNoModal: false })}
          okTransl={ok_text}
          cancelTransl={cancel_text}
        />
        <WarningInfoModal
          dirRtl={dirRtl}
          show={showInterruptProsessModal}
          title={attention_prosess_interrapted}
          text={care_your_package}
          onModalCloseClick={() => this.onClickInterruptProsessModal()}
          btnText={close_text}
        />
      </div>
    )
  }
}

const mapStateToProps = ({
  userLogin,
  prices,
  translate,
  bgService,
  errorMessages,
}) => {
  let { firstName } = userLogin
  const { pricesArrs } = prices
  const { stationId } = bgService
  const { serviceInternetError, reactInternetError, doNotInterruptTheProcess } =
    errorMessages

  const {
    dirRtl,
    asterisk,
    customer_service_text,
    customer_service_phone_text,
    customer_service_whatsapp_text,
    close_text,
    price_list,
    login_courier,
    sms_login_didnot_get_sms,
    forgot_password_btn_text,
    reset_pwd_modal_title,
    reset_pwd_modal_body,
    register_btn_text,
    logout_btn_text,
    logout_modal_title,
    logout_modal_text,
    ok_text,
    cancel_text,
    langName,
    attention_prosess_interrapted,
    care_your_package,
  } = translate

  return {
    firstName,
    dirRtl,
    customer_service_text,
    customer_service_phone_text,
    customer_service_whatsapp_text,
    asterisk,
    pricesArrs,
    close_text,
    price_list,
    login_courier,
    sms_login_didnot_get_sms,
    forgot_password_btn_text,
    reset_pwd_modal_title,
    reset_pwd_modal_body,
    register_btn_text,
    logout_btn_text,
    logout_modal_title,
    logout_modal_text,
    ok_text,
    cancel_text,
    langName,
    stationId,
    serviceInternetError,
    reactInternetError,
    doNotInterruptTheProcess,
    attention_prosess_interrapted,
    care_your_package,
  }
}

export default connect(mapStateToProps, {
  LogoutUser,
  recreateUserPassword,
  fetchPriceListByStationId,
  reportFBEvent,
})(withRouter(FixedHeader))
